import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const templateApi = {
  list: () => axios.get(`${API}/templates`).then((r) => r.data),
  get: (id) => axios.get(`${API}/templates/${id}`).then((r) => r.data),
  create: (data) => axios.post(`${API}/templates`, data).then((r) => r.data),
  update: (id, data) =>
    axios.put(`${API}/templates/${id}`, data).then((r) => r.data),
  delete: (id) => axios.delete(`${API}/templates/${id}`).then((r) => r.data),
  duplicate: (id) =>
    axios.post(`${API}/templates/${id}/duplicate`).then((r) => r.data),
};

export const customElementApi = {
  list: () => axios.get(`${API}/custom-elements`).then((r) => r.data),
  create: (data) => axios.post(`${API}/custom-elements`, data).then((r) => r.data),
  update: (id, data) => axios.put(`${API}/custom-elements/${id}`, data).then((r) => r.data),
  delete: (id) => axios.delete(`${API}/custom-elements/${id}`).then((r) => r.data),
};

export const elementDefaultsApi = {
  list: () => axios.get(`${API}/element-defaults`).then((r) => r.data),
  save: (type, overrides) => axios.put(`${API}/element-defaults/${type}`, { overrides }).then((r) => r.data),
  reset: (type) => axios.delete(`${API}/element-defaults/${type}`).then((r) => r.data),
  applyToTemplates: (type) => axios.post(`${API}/element-defaults/${type}/apply-to-templates`).then((r) => r.data),
};

export const snippetApi = {
  list:   ()         => axios.get(`${API}/snippets`).then((r) => r.data),
  create: (data)     => axios.post(`${API}/snippets`, data).then((r) => r.data),
  update: (id, data) => axios.put(`${API}/snippets/${id}`, data).then((r) => r.data),
  delete: (id)       => axios.delete(`${API}/snippets/${id}`).then((r) => r.data),
};
